import MainLayout from '@/shared/layout/main-layout';
import Activity from './activity';

export default [
  {
    path: '/activity',
    component: MainLayout,
    meta: { auth: true },
    children: [
      {
        name: 'activity',
        path: '',
        component: Activity,
        meta: { auth: true },
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/activity/activity-routes.js